<div nz-row *ngIf="page === 1" class="word-block">
	<div *ngFor="let word of firstPattern" nz-col class="block">{{ words[word] }}</div>
</div>
<div nz-row *ngIf="page === 2" class="word-block">
	<div *ngFor="let color of secondPattern" nz-col class="block"
		[ngClass]="{'block-green': color === 'G', 'block-red': color === 'R', 'block-blue': color === 'B'}">
	</div>
</div>
<div nz-row *ngIf="page === 3" class="word-block">
	<div *ngFor="let color of thirdPatternColors, let i = index" nz-col class="block"
		[ngClass]="{'word-green': color === 'G', 'word-red': color === 'R', 'word-blue': color === 'B'}">
		{{ words[thirdPatternWords[i]] }}
	</div>
</div>

<div class="extrabuttons buttonrow replaceButtonrow">
	<div class="left-buttons"></div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="primary" class="big-button right-one" (touchstart)="dispatchVitaReact($event)" (mousedown)="dispatchVitaReact($event)">
			{{ 'actions.stop' | translate }}
		</button>
	</div>
</div>
